import { Outlet } from 'react-router-dom'
import ReportsNav from './ReportsNav'

/**
 * Shell for everything under /reports.
 *
 * Mirrors AdminLayout so the two panels read as the same kind of thing. The
 * device sidebar is suppressed for these paths in NewMainLayout — two sidebars
 * would leave the report list in a column narrower than one of its own tables.
 */
export default function ReportsLayout() {
  return (
    <div className="flex h-[calc(100vh-4rem)] -mx-4 sm:-mx-6 lg:-mx-8 -my-6">
      <aside className="w-64 shrink-0 bg-white border-r border-gray-200 overflow-y-auto">
        <div className="p-4 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900 whitespace-nowrap">Report Panel</h1>
        </div>
        <ReportsNav />
      </aside>

      <main className="flex-1 min-w-0 overflow-auto p-8 bg-gray-50">
        <Outlet />
      </main>
    </div>
  )
}
